// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";

function Block(props) {
  var __className = props.className;
  var __padding = props.padding;
  var bottomElement = props.bottomElement;
  var topElement = props.topElement;
  var padding = __padding !== undefined ? __padding : "p-5";
  var className = __className !== undefined ? __className : "";
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var topBlock = topElement !== undefined ? Caml_option.valFromOption(topElement) : null;
  var actionBlock = bottomElement !== undefined ? Caml_option.valFromOption(bottomElement) : null;
  var divider = topElement !== undefined && bottomElement !== undefined ? React.createElement("div", {
          className: "BlockDivider",
          style: {
            marginTop: themeObj.spacingUnit,
            marginBottom: themeObj.spacingUnit
          }
        }) : null;
  return React.createElement("div", {
              className: "Block flex flex-col " + padding + " " + className,
              style: {
                lineHeight: themeObj.fontLineHeight
              }
            }, React.createElement("div", {
                  className: "BlockTop"
                }, topBlock), divider, React.createElement("div", {
                  className: "BlockAction"
                }, actionBlock));
}

var make = Block;

export {
  make ,
}
/* jotai Not a pure module */
